import {
  AdjustmentsVerticalIcon,
  CogIcon,
  EnvelopeIcon,
  QuestionMarkCircleIcon,
  ArrowPathIcon,
  UsersIcon,
  QueueListIcon,
  DocumentChartBarIcon,
  DocumentMagnifyingGlassIcon,
} from "@heroicons/react/24/outline";

import Users from "./pages/Users";
import Changelog from "./pages/Changelog";
import EditUser from "./pages/EditUser";
import EditPermission from "./pages/EditPermission";
import Handover from "./pages/Handover";
import Roles from "./pages/Roles";
import EditRole from "./pages/EditRole";
import Support from "./pages/Support";
import EmailFooter from "./pages/EmailFooter";
import Configuration from "./pages/Configuration";
import ReportJobs from "./pages/ReportJobs";
import ActiveReportExports from "./pages/ActiveReportExports";
import CompanyIcon from "../../assets/icons/CompanyIcon";

const routes = [
  {
    element: Changelog,
    href: "changelog",
    icon: QueueListIcon,
    name: "Changelog",
    permissions: ["ADMIN_MODULE"],
  },
  {
    element: Roles,
    href: "role",
    icon: AdjustmentsVerticalIcon,
    name: "Role",
    permissions: ["READ_ROLE"],
  },
  {
    element: EditRole,
    href: "role/:id/edit",
    permissions: ["READ_ROLE", "UPDATE_ROLE"],
  },
  {
    element: EditRole,
    href: "role/new",
    permissions: ["READ_ROLE", "CREATE_ROLE"],
  },
  {
    element: Users,
    href: "users",
    icon: UsersIcon,
    name: "User",
    permissions: ["READ_USER", "ADMIN_MODULE"],
  },
  {
    element: EditUser,
    href: "users/:id/edit",
    permissions: ["READ_USER", "UPDATE_USER"],
  },
  {
    element: EditPermission,
    href: "users/:id/edit/permission",
    permissions: ["READ_USER", "UPDATE_USER", "UPDATE_PERMISSION"],
  },
  {
    element: Support,
    href: "support",
    icon: QuestionMarkCircleIcon,
    name: "Support",
  },
  {
    element: Support,
    href: "support/*",
  },
  {
    element: Handover,
    href: "handover",
    icon: ArrowPathIcon,
    name: "Handover",
  },
  {
    element: EmailFooter,
    href: "email-footer",
    icon: EnvelopeIcon,
    name: "Email footer",
  },
  {
    href: "/companies",
    icon: CompanyIcon,
    name: "Companies",
  },
  {
    element: Configuration,
    href: "configuration",
    icon: CogIcon,
    name: "Configuration",
  },
  {
    element: ReportJobs,
    href: "report-jobs",
    icon: DocumentChartBarIcon,
    name: "Report jobs",
    permissions: ["ADMIN_MODULE"],
  },
  {
    element: ActiveReportExports,
    href: "active-report-exports",
    icon: DocumentMagnifyingGlassIcon,
    name: "Active report exports",
    permissions: ["ADMIN_MODULE"],
  },
];

export default routes;
